module.exports = __webpack_public_path__ + "img/icon-tax-arrow-right.57ea30df.svg";